module.exports = __webpack_public_path__ + "img/2.e43dc38a.jpg";